module.exports = __webpack_public_path__ + "img/flag-HN.e1198409.png";